import StringUtility from 'utils/stringReplacement';

const copy = new StringUtility({
  errors: {
    permissions: {
      description: `Missing or insufficient permissions`,
      title: `Access not granted`,
    },
    reason: `If you believe this to be an error, please send us an email to support@fanai.io and let us know.`,
    userNotFound: {
      description: 'User not found',
      title: 'Unable to retrieve clients and/or users at this time',
    },
  },
});

export default copy;
